var map = {
	"./blocksLvl1.json": "f26d",
	"./blocksLvl2.json": "273a",
	"./blocksLvl3.json": "f3d3",
	"./blocksLvl4.json": "0abb",
	"./blocksLvl5.json": "3bc6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bc8d";